export default "__VITE_ASSET__C_RMhV1J__"